// Generated by scripts/image-dimensions.mjs. The size of each migrated picture
// as displayed, [width, height], by Cloudinary public id.
const sizes = {"1-1_dnx0kl":[4000,6000],
"101_kkdr66":[3831,5747],
"103_o2d1mw":[3362,5043],
"103_wxodby":[3296,4944],
"105_gy0pnv":[6000,4000],
"108_fbhntj":[3505,5257],
"10_bk34yz":[4000,6000],
"10_cvmmxq":[3999,2684],
"10_czwafx":[1469,2190],
"10_loomi9":[4000,6000],
"10_p89ebx":[3913,5909],
"10_rnny5c":[5900,3933],
"10_wahy8p":[4000,6000],
"10_wfudp5":[4000,6000],
"10_xgsxfg":[2274,3130],
"11.1_tvqhgz":[4000,6000],
"110_dya46m":[3317,4975],
"112_eg9nhf":[3312,2025],
"114_frqbnc":[6000,4000],
"115_yqxtjs":[3353,5030],
"118_balmwr":[3348,5022],
"11_bhsmdl":[5803,3877],
"11_bygawx":[2906,1745],
"11_jj4syg":[923,1385],
"11_kwrqel":[1024,683],
"11_odhu4z":[3935,5942],
"11_rfxc3v":[4000,2679],
"11_sjkxab":[4000,6000],
"11_tbclul":[3848,5691],
"121_izl3vy":[3194,2084],
"122_lvfmu6":[4000,6000],
"127_vhfmun":[3193,4789],
"129_eyzl2y":[4000,6000],
"12_pdfvnf":[3553,4906],
"12_qgfai2":[3905,5690],
"12_skahlo":[3833,5768],
"12_zsmxmi":[4000,5888],
"13.1_ikbcow":[6000,4000],
"130_yljtys":[3044,4566],
"133_dm5xtj":[4000,6000],
"135_zse4fd":[6000,4000],
"139_jkzbcc":[6000,4000],
"13_d5oflk":[3771,5649],
"13_fxaroa":[4244,3015],
"13_umef87":[2456,3346],
"13_us2erb":[3463,5194],
"140_pb97zw":[6000,4000],
"143_oxtt5v":[3143,4715],
"144_wxvqpd":[3402,5103],
"145_zqnffl":[2898,4382],
"146_eiz1s9":[5655,3770],
"14_eyjwfz":[3871,5882],
"14_l1xfyu":[6000,4000],
"14_qb7yrb":[4000,6000],
"14_zglwp5":[4000,6000],
"15.1_rlpy6q":[4000,6000],
"151_iov2pj":[6000,4000],
"155_jb8po3":[3807,5710],
"15_axfk9b":[3757,5636],
"15_j0wmp4":[1024,683],
"15_jkfbab":[4000,6000],
"15_nojozq":[4000,6000],
"15_nvljlb":[4000,6000],
"15_rt60wo":[3839,5758],
"15_yh0dr1":[5294,3567],
"16_f7xrvd":[4000,6000],
"16_hlbmmy":[3462,4724],
"16_iyrggz":[3090,4502],
"16_kav7ne":[4000,6000],
"16_kdlozt":[4000,5916],
"17.1_mkliyd":[4000,6000],
"17_1_ajqkwp":[1437,958],
"17_ezvnas":[3990,5985],
"17_jac9cm":[3794,5691],
"17_mgfpws":[4000,5438],
"17_uulxxi":[4000,6000],
"18_bhrnkw":[5195,3321],
"18_blowxt":[5550,3700],
"18_o71cgq":[3928,5793],
"18_qbaajv":[3706,4991],
"19_mhx42w":[3011,4516],
"19_rtrdo2":[5855,3932],
"19_xpmkqg":[4000,6000],
"19_y5f6ge":[6000,4000],
"1_igbpis":[3545,5145],
"1_kwa98v":[6000,4000],
"1_lqlqcj":[3509,5263],
"1_mmqrcu":[3250,4875],
"1_olpscr":[6000,4000],
"1_tonuvd":[5071,3254],
"1_wtkged":[3522,5283],
"1_xrpbab":[1586,1057],
"20_rpurs3":[4000,6000],
"20_ufg7u7":[4000,6000],
"21_blgcco":[1024,695],
"21_fzenns":[4000,6000],
"21_h3qcxn":[3981,2721],
"22_agnz8q":[3695,5542],
"22_bsaqu0":[4000,6000],
"22_crerz3":[2704,4056],
"22_eoosis":[3696,5453],
"22_rvz13e":[3103,4518],
"23_azljqr":[3829,5668],
"24_afjm86":[3999,2682],
"24_heypd8":[3697,5775],
"24_lr45w3":[7393,5545],
"24_rjecji":[3581,5372],
"26_fbbbuw":[5182,3866],
"26_pdqjso":[6000,4000],
"27_d1addf":[8064,6048],
"27_eg9eek":[3043,4256],
"27_lslibe":[4000,6000],
"27_wtjaon":[3502,5253],
"27_y8bmyg":[3342,5013],
"28_btcmjc":[5450,3633],
"28_e1vbyh":[2907,4360],
"29_oxqkgj":[4000,2589],
"29_rt56xi":[2732,4098],
"29_zvzoey":[3833,2627],
"2_alxdl6":[3873,5380],
"2_elkpzx":[5664,2924],
"2_h747a6":[1320,1980],
"2_kppmaw":[5301,3534],
"2_rasgws":[3727,2458],
"2_siq5wd":[4000,6000],
"2_vnb3ut":[3901,5923],
"2_wbktrw":[4000,6000],
"2_xtnsrg":[2979,4469],
"2_zp8er3":[1966,2949],
"30_aywtqn":[3875,5812],
"31_py8i6t":[4000,6000],
"32_jdnvbq":[4000,6000],
"32_l920ql":[3142,2048],
"32_v1w57i":[3194,4425],
"34_ljezvs":[4000,6000],
"35_tmralc":[4914,3276],
"37_n5p8as":[3031,4546],
"38_dcj19o":[3901,5852],
"38_hgguop":[2055,3082],
"38_nqxkgh":[3913,2450],
"39_v80quh":[3175,4763],
"3_dtfr1c":[3245,4534],
"3_j6hsaj":[3815,5421],
"3_j8y4d1":[2905,4117],
"3_ldnpsc":[3596,5166],
"3_owiqq7":[1180,1617],
"3_wbw3dj":[4000,6000],
"3_z2bfoi":[1846,2776],
"40_hpzup5":[4000,6000],
"40_vxzhbu":[3623,5435],
"41_rmouxg":[3588,5473],
"41_uyr8t3":[2811,4217],
"42_jx5nex":[3747,5620],
"43_pcpd7p":[4000,6000],
"43_v7znjj":[3255,4882],
"44_av3j4m":[2715,4073],
"45_jys5ox":[3227,3794],
"45_y3buyi":[4000,6000],
"48_vnn7hh":[3806,5487],
"49_icejso":[3675,5512],
"4_1_qmg2lh":[1303,1955],
"4_bxn2jt":[3925,5754],
"4_ihauzo":[5445,3468],
"4_ljpc4w":[3975,5962],
"4_ohocbg":[3955,4994],
"4_shficy":[4813,3209],
"4_so416v":[4818,3212],
"4_tf38nj":[2737,3863],
"4_u4svaq":[3767,5640],
"4_ue70cj":[3772,5658],
"4_uoenvu":[683,1024],
"50_b1d2ns":[3012,4518],
"50_st2m0v":[2361,3542],
"52_nb0lzl":[4995,3330],
"53_rwcpgu":[3315,4973],
"54_vgxg0k":[5058,3372],
"55_khrmwe":[2555,3772],
"55_qq4xms":[2826,4239],
"56_eqt9ne":[4888,3259],
"56_iubx1a":[4000,6000],
"5_cuqffx":[5759,3839],
"5_gnuleb":[3759,5370],
"5_hgwd0o":[3065,4998],
"5_kuyahn":[2724,4086],
"5_pscgkg":[6000,4000],
"5_qcuias":[3498,5198],
"5_wgqkje":[3860,5790],
"5_xf4al7":[5236,3491],
"5_zmtaev":[4000,5879],
"60_gcfwgh":[2870,4208],
"63_vfnzfv":[4000,6000],
"64_qjmktn":[4000,6000],
"64_yrlibf":[3344,5016],
"66_x73ff9":[5872,3889],
"69_wvyvxo":[4000,6000],
"6_ee1agu":[3712,5051],
"6_gma4u8":[1227,1840],
"6_mmkwtg":[3810,5793],
"6_mrqx5q":[4000,6000],
"6_pezl8f":[3891,5632],
"6_svlvlq":[2847,1704],
"7.1_ojk2g4":[3719,5522],
"73_kjiyfj":[3533,5299],
"73_w4esrm":[2762,4143],
"74_mj4gh7":[3257,4886],
"77_gnkiay":[2717,4075],
"78_htcf5r":[3133,4700],
"78_ri34ls":[4000,6000],
"7_1_p4ycnv":[998,1495],
"7_a2omnq":[3931,5909],
"7_b5mwxs":[5941,3961],
"7_di4fnn":[683,1024],
"7_dioqsj":[3712,2719],
"7_fcqian":[3575,2563],
"7_fzne0b":[4000,6000],
"7_gu7tz8":[3719,5522],
"8.1_vsash3":[3155,4329],
"80_hph0rs":[6000,4000],
"82_hba26m":[5276,3517],
"84_zqntsk":[4000,6000],
"88_mx54xa":[3835,5753],
"8_js8tn0":[4000,5844],
"8_jzxzsm":[3840,5476],
"8_lcrhcc":[3155,4329],
"8_p3voqm":[6000,4000],
"8_x3jty1":[3457,4565],
"8_xzgun9":[4907,2939],
"95_yfaeyj":[6000,4000],
"9_1_h4tmsj":[1000,1500],
"9_chwqih":[3587,5044],
"9_da93ql":[3833,5500],
"9_f5xraa":[3706,5211],
"9_gc8ak4":[3482,5410],
"9_hatxmf":[683,1024],
"9_kevevf":[3468,5440],
"9_lsq7bq":[2839,1959],
"9_t17lwt":[6000,4000],
"A_man_framed_g9bami":[1400,2018],
"A_man_qoejaw":[4000,6000],
"Astrup_Fearnley_museum_of_modern_art_zakabw":[683,1024],
"Astrup_framed_2_oy7yyz":[1960,1960],
"Astrup_framed_xpjodb":[650,650],
"Aurora_Sauna_Sandnes_10_xl0jpv":[4000,6000],
"Aurora_Sauna_Sandnes_13_p9jamm":[3925,5888],
"Aurora_Sauna_Sandnes_1_futk9t":[5986,3991],
"Aurora_Sauna_Sandnes_3_lvd4bv":[3490,5235],
"Aurora_Sauna_Sandnes_4_rkavgd":[5410,3607],
"Aurora_Sauna_Sandnes_7_kniwyi":[4000,6000],
"Aurora_sauna_13_qmtxy5":[5074,3383],
"Aurora_sauna_4_frlwle":[3951,5927],
"Bj%C3%B8rvika_framed_uynnfi":[1400,2018],
"Bj%C3%B8rvika_ppzwmo":[4000,6000],
"Bj%C3%B8rvika_sykkel_2_ugj8p2":[1024,689],
"Bj%C3%B8rvika_sykkel_framed_vnyooe":[2100,1400],
"Des.OEA.24_nubsr5":[683,1024],
"Des.OEA._1_j4za2d":[1024,683],
"Des.OEA._22_figkee":[683,1024],
"Des.OEA._3_qmzeei":[1024,683],
"Des.OEA._4_p7vqil":[1024,683],
"Des.OEA._5_jhrg89":[1024,683],
"Disapearing_framed_2_ryiq1k":[2000,1500],
"Disapearing_framed_r062jo":[1000,1500],
"Disappearing_mpu1io":[3349,4637],
"Embla_keramikk_11_dcqjnx":[3990,5971],
"Embla_keramikk_1_uxfrrk":[3632,4870],
"Embla_keramikk_4_xuvd8p":[3306,3577],
"Embla_keramikk_6_boiia7":[5383,3715],
"Embla_keramikk_9_vppa2p":[5574,3713],
"FASADE_1_ifln4r":[2851,3535],
"FASADE_3_mqhqxj":[6000,4000],
"FASADE_4_ordfg5":[3229,4000],
"FASADE_5_xmn8t8":[3648,4731],
"FASADE_BILDE_1_nhtne2":[4000,6000],
"FASADE_BILDE_jfjr47":[4000,6000],
"FASADE_BILDE_nyuptw":[6000,4000],
"FASADE_BILDE_rffiiw":[4000,5687],
"FASADE_BILDE_tl41ya":[3918,6000],
"FASADE_BILDE_wdzxag":[3918,6000],
"FASADE_b8dprv":[3688,5210],
"FASADE_byxzzx":[3229,4000],
"FASADE_ghewnp":[5733,3822],
"FASADE_i4ozcy":[3652,5483],
"FASADE_iuq084":[3986,5979],
"FASADE_jao9rc":[2557,3616],
"FASADE_k6kjhi":[6000,4000],
"FASADE_kwcnli":[6000,4000],
"FASADE_ltcbzg":[3849,5773],
"FASADE_mx2hhd":[6000,4000],
"FASADE_pmkkru":[5638,4000],
"FASADE_psfagm":[2972,2034],
"FASADE_tbem9s":[5846,3898],
"FASADE_vjvlub":[2902,3931],
"FASADE_weuvtp":[3728,5592],
"FASADE_xksuen":[2851,3535],
"FASADE_yauxdg":[5372,3495],
"FASADE_z0pgvq":[3648,4731],
"Fagottkor_10_oqitdi":[1753,2629],
"Fagottkor_12_a6gvz8":[1973,2960],
"Fagottkor_13_slzzi4":[2534,1689],
"Fagottkor_14_idfemu":[3065,2043],
"Fagottkor_15_zexpmx":[4070,2713],
"Fagottkor_17_hk76l2":[3505,2337],
"Fagottkor_18_zsyiix":[4356,2904],
"Fagottkor_19_uuefqk":[1460,2190],
"Fagottkor_1_u4qozh":[5930,3953],
"Fagottkor_22_cddost":[3515,2343],
"Fagottkor_23_r7cz3j":[3604,2403],
"Fagottkor_24_pbatc5":[3808,2539],
"Fagottkor_27_adz1eh":[3413,2275],
"Fagottkor_28_zz724l":[1939,2909],
"Fagottkor_29_ljfwu7":[2133,3199],
"Fagottkor_2_a2upca":[5469,3646],
"Fagottkor_30_uur6vn":[1973,2906],
"Fagottkor_32_bgjtv4":[4122,2748],
"Fagottkor_35_ockqps":[2761,1841],
"Fagottkor_37_hglsij":[1993,2989],
"Fagottkor_39_nsbnht":[2944,1963],
"Fagottkor_3_je29wk":[3640,2427],
"Fagottkor_40_gfaopo":[5245,3497],
"Fagottkor_41_huxcb5":[2932,1955],
"Fagottkor_42_e2fosh":[2581,3872],
"Fagottkor_45_loiu7u":[3369,2246],
"Fagottkor_46_ozsllc":[2290,1527],
"Fagottkor_48_boa8zj":[3428,2285],
"Fagottkor_49_n94apb":[1709,2500],
"Fagottkor_4_nga7tf":[3501,2334],
"Fagottkor_51_qtvgu6":[2657,1771],
"Fagottkor_52_h6znwp":[4767,3178],
"Fagottkor_57_z8zp0o":[3781,2521],
"Fagottkor_58_bgcut1":[4553,3035],
"Fagottkor_59_nfbq3r":[3639,2426],
"Fagottkor_5_rzfhhd":[5449,3633],
"Fagottkor_8_fuj1zq":[2157,3236],
"Fagottkor_9_wywnw7":[1884,2826],
"Fasade_s7tqiz":[6000,4000],
"Fasadebilde_htnajq":[5523,3682],
"Fisherman_house_in_Nida_framed_c0gcki":[1400,2100],
"Fisherman_house_in_Nida_jatsxf":[683,1024],
"Food_2_gf6pzy":[5480,3653],
"Food_3_tvozt7":[5891,3927],
"Food_4_sgb9as":[5499,3666],
"Food_airmd5":[6000,4000],
"Forest_framed_2_fvjqj1":[612,344],
"Forest_ph8k7c":[6000,4000],
"Frozen_frame_uspsbt":[2000,2000],
"Frozen_time_yscvbu":[683,1024],
"HOVEDBILDE_bmkuok":[7654,5741],
"Hovedfoto_dyv1p2":[1024,710],
"Jarle_10_d8w8ng":[7008,4672],
"Jarle_11_gqnrij":[3419,5129],
"Jarle_12_gi72gz":[3222,4832],
"Jarle_13_uwur0x":[4259,6389],
"Jarle_14_obxqc2":[3032,4548],
"Jarle_15_cwrkfe":[7008,4672],
"Jarle_16_md0jvk":[5303,3530],
"Jarle_17_py1eev":[4672,7008],
"Jarle_18_kshwa4":[6108,4072],
"Jarle_19_FASDE_BILDE_srgp3j":[3859,5789],
"Jarle_1_dkmeil":[4163,6244],
"Jarle_20_gkbggd":[6298,4199],
"Jarle_21_ngwyrd":[3929,5894],
"Jarle_2_qxlujc":[5654,3769],
"Jarle_3_jxzbpd":[3615,5423],
"Jarle_4_hxgswv":[3721,5582],
"Jarle_5_kge6zb":[4035,6052],
"Jarle_6_jdfyri":[4345,6517],
"Jarle_8_mmkebo":[4346,6519],
"Jarle_9_i4bhby":[6158,4105],
"Kampen_2_pv8xua":[4000,6000],
"Kampen_can_framed_sw1fsp":[1400,1903],
"Kampen_cat_s5lkg1":[3756,5414],
"Kampen_framed_gaup8f":[1400,2100],
"Klaipeda_framed_rcxlj0":[650,650],
"Klaipeda_yyxsnt":[6000,4000],
"NAM_2_mojatp":[3402,4789],
"NAM_tkvamp":[1716,1077],
"Nasjonalmuseet_2_x6za1w":[2747,4257],
"Nationalmuseet_sun_x1aklq":[3429,5384],
"Nordenga_framed_xqux6c":[750,1000],
"Nordenga_sr9dhp":[683,1024],
"Nydalen2_qqywzp":[4000,6000],
"Nydalen3_glkhxj":[4000,6000],
"Nydalen4_kzrymb":[3837,5756],
"Nydalen5_abbbuf":[3607,5464],
"Nydalen6_isibzi":[4000,6000],
"Nydalen7_jpi5mn":[6000,4000],
"Nydalen8_q1kikz":[4000,6000],
"Oslo_bus_1_ipq7lo":[683,1024],
"Oslo_bus_zgzeg4":[1400,2013],
"Plaka_Greece_framed_1_kmg0mt":[2000,1998],
"Plaka_Greece_z2n2vr":[683,1024],
"Polestar3_bie25n":[4000,3044],
"Polestar_4_b7xx3x":[4000,3113],
"Polestar_lamp_hqij6v":[6000,4000],
"Polestar_logo_wbql7u":[4509,3465],
"Polestar_rakena_oouaph":[4000,6000],
"Polestar_ypn2hq":[4000,2753],
"River_framed_xmql7k":[600,400],
"River_uxtqt6":[1024,683],
"SM_10_avkszt":[6000,4000],
"SM_11_ch1dtn":[6000,4000],
"SM_12_udjx1d":[6000,4000],
"SM_13_iaibtg":[6000,4000],
"SM_14_tifgk3":[6000,4000],
"SM_15_thxuus":[6000,4000],
"SM_2_zwshgs":[6000,4000],
"SM_3_jpgegc":[6000,4000],
"SM_4_ovpkbo":[6000,4000],
"SM_5_e2whc2":[5431,3621],
"SM_6_lu1nmz":[6000,4000],
"SM_7_fql9fp":[6000,4000],
"SM_8_i219r2":[5938,3959],
"SM_9_iqebuz":[6000,4000],
"S_L_10_x6q22h":[3506,5015],
"S_L_11_pkecfk":[3729,4980],
"S_L_12_smi6d8":[3951,5892],
"S_L_14_yjko8c":[3641,5604],
"S_L_18_z5xgmw":[3610,5230],
"S_L_22_z3hzz0":[3850,5775],
"S_L_26_bd7chi":[4000,6000],
"S_L_28_c0wrqv":[3827,5655],
"S_L_29_tir5u7":[4000,6000],
"S_L_2_anp5mi":[4000,6000],
"S_L_30_ypy3tg":[4000,6000],
"S_L_32_czqmui":[3738,5574],
"S_L_34_mbsuwm":[3562,5343],
"S_L_35_vbllfo":[4000,6000],
"S_L_37_giqz00":[3698,5397],
"S_L_40_xdoxti":[4000,6000],
"S_L_41_yxew0p":[3708,5224],
"S_L_45_enweq9":[4000,6000],
"S_L_46_hlkwgq":[4000,6000],
"S_L_47_rcnpdq":[4000,6000],
"S_L_4_uuxaia":[3817,5481],
"S_L_51_b6ezbn":[4000,6000],
"S_L_56_c7hbsd":[4000,6000],
"S_L_57_pjsol4":[5295,3569],
"S_L_63_igmo5m":[4000,6000],
"S_L_6_t9aux6":[3111,4677],
"S_L_8_w0a1vv":[3931,5900],
"Sauna_Aurora_Nesbyen_14_1_iueynh":[2389,3583],
"Sauna_Aurora_Nesbyen_15_wwdofa":[3824,2549],
"Sunset_framed_1_sxzcqz":[1700,1133],
"Sunset_framed_2_gzomgt":[1100,1191],
"Sunset_mno4gy":[2796,3901],
"T11_qsvx2s":[3408,5378],
"T18_nymwpr":[2510,1803],
"T1_iobtii":[3833,5309],
"T20_xisimv":[1944,2907],
"T23_tfdngk":[3763,2458],
"T25_iemfah":[3198,2168],
"T26_dz3vyn":[5401,3516],
"T29_t9a9qe":[3137,4331],
"T30_avnwq8":[1829,2390],
"T31_xrofbc":[2965,2089],
"T6_fkcues":[5415,3740],
"T8_ilmykr":[3018,4000],
"The_horizont_x0hd9h":[683,1024],
"The_orizont_framed_2_ctu6hq":[2560,2560],
"The_orizont_framed_v6b9dv":[650,650],
"The_way_framed_bnklw7":[650,650],
"The_way_lesd0x":[3965,5948],
"Tustna_framed_fgxoxp":[650,650],
"Tustna_rteeoy":[5359,3573],
"Tuva_ped.even.17_jh3v5k":[3851,5776],
"Tuva_ped.even.18_auunbc":[4000,6000],
"Tuva_ped.even.1_lpwgmi":[5586,3724],
"Tuva_ped.even.23_q9z6qu":[3425,5138],
"Tuva_ped.even.24_n3euxw":[3587,5380],
"Tuva_ped.even.32_bfxca6":[3839,5758],
"Tuva_ped.even.34_bytyh5":[4000,6000],
"Tuva_ped.even.37_bqxcn1":[4000,6000],
"Tuva_ped.even.38_hoegxc":[6000,4000],
"Tuva_ped.even.39_roziq0":[4000,6000],
"Tuva_ped.even.44_gorvz8":[4000,6000],
"Tuva_ped.even.46_rwnzxo":[4000,6000],
"Tuva_ped.even.47_se0tll":[6000,4000],
"Visual_Oslo_framed_ojdijt":[2000,2000],
"Visual_Oslo_rx8tn6":[683,1024],
"Walking_alone_2_zyvuob":[2000,2000],
"Walking_alone_3_h6d1ez":[1300,1300],
"Walking_alone_amgywm":[683,1024],
"_DSC1053_kcsb3e":[6000,4000],
"_DSC1119_rs42dh":[6000,4000],
"_DSC1132_or2hd3":[6000,4000],
"_DSC1135_hwvk44":[6000,4000],
"_DSC1158_mbpojq":[6000,4000],
"_DSC1211_xriy3c":[4000,6000],
"_DSC1333_uflcwi":[6000,4000],
"_DSC1405_tiucqa":[6000,4000],
"_DSC1436_efxuic":[4000,6000],
"_DSC1448_hm0sg4":[6000,4000],
"_DSC1454_rtypkk":[6000,4000],
"_DSC1534_bgwgjt":[4000,6000],
"_DSC1548_w2scpg":[4000,6000],
"_DSC1582_e0gslt":[4000,6000],
"_DSC1597_xdvm9x":[6000,4000],
"_DSC1635_lyzcdu":[6000,4000],
"_DSC5462_psuaux":[6000,4000],
"_DSC5480_bsvt7t":[6000,4000],
"_DSC5483_xk3gi3":[6000,4000],
"_DSC5489_l9x8xk":[6000,4000],
"_DSC5510_zlwqtd":[6000,4000],
"_DSC5534_mcvi9t":[6000,4000],
"_DSC5564_qxu7f8":[4000,6000],
"_DSC5571_f53z0l":[6000,4000],
"_DSC5578_w6vajc":[3896,5838],
"_DSC5601_v5x8vc":[4000,6000],
"_DSC5619_gnzhyr":[4000,6000],
"_DSC5631_bryxtc":[6000,4000],
"_DSC5637_ac5s4q":[3647,5039],
"_DSC5664_etf0mf":[4450,2225],
"_DSC5746_zr7lwa":[4991,3312],
"_DSC5786_verwiq":[6000,4000],
"_DSC5888_kpipgo":[3476,4902],
"_DSC5968_ceuzpt":[6000,4000],
"_DSC6048_tucgp3":[3746,5696],
"_DSC6165_wv0rzu":[2753,3865],
"_DSC7120_mgvuzm":[4000,6000],
"_DSC7129_p9bfuf":[6000,4000],
"_DSC7158_nyevo8":[6000,4000],
"_DSC7170_wrpbcy":[6000,4000],
"_DSC7173_alp8di":[6000,4000],
"_DSC7205_cblbcd":[4000,6000],
"_DSC7211_bmkwos":[6000,4000],
"_DSC7213_xeuvk9":[4000,6000],
"_DSC7222_alwm5n":[6000,4000],
"_DSC7232_vr2zvv":[6000,4000],
"_DSC7264_wy1438":[4000,6000],
"_DSC7281_p0ndf4":[6000,4000],
"_DSC8840_lirbjm":[6000,4000],
"_DSC8863_mvzfbr":[6000,4000],
"_DSC8866_hxmyx7":[6000,4000],
"_DSC8869_vpzkxh":[6000,4000],
"_DSC8919_qspo9s":[4000,6000],
"_DSC8927_iz8pgy":[6000,4000],
"frozen_framed_qnnedw":[1024,969]};

export default sizes;
